<template>
    <div
        tabindex="-1"
        aria-labelledby="offcanvasAddUserLabel"
    >
        <div class="offcanvas-header border-bottom">
            <h5 id="offcanvasAddUserLabel" class="offcanvas-title">
                CEK LOG SARANA {{ sarana[ceklog.kodeUnit] }}
            </h5>
        </div>
        <div class="offcanvas-body mx-0 flex-grow-0 p-6 h-100">
            <div class="col-xl">
                <form
                    @submit.prevent="send"
                    autocomplete="off"
                    autocapitalize="on"
                >
                    <div class="mb-3">
                        <label class="form-label" for="nomorLambung"
                            >UNIT SARANA (LIGHT VEHICLES)
                        </label>
                        <select
                            class="form-control"
                            id="nomorLambung"
                            name="kodeUnit"
                            placeholder="NOMOR LAMBUNG"
                            v-model="ceklog.kodeUnit"
                            required="required"
                            disabled="disabled"
                        >

                        <option value="" selected="selected">-- Pilih --</option>
                        <option  v-for="(i,k) in sarana" :value="k"> {{ i }}</option>
                    </select>
                    </div>
                    <div class="mb-3">
                        <label class="form-label" for="tanggal"
                            >Tanggal</label
                        >
                        <input
                            type="date"
                            class="form-control"
                            id="tanggal"
                            v-model="ceklog.tanggal"
                            required="required"
                            disabled="disabled"
                        />
                    </div>

                    <div class="mb-3">
                        <label class="form-label" for="jam">Waktu</label>
                        <input
                            type="time"
                            class="form-control"
                            id="jam"
                            v-model="ceklog.jam"
                            placeholder="Waktu"
                            step="2"
                            required="required"
                            disabled="disabled"
                        />
                    </div>
                    <div class="mb-3">
                        <label class="form-label" for="Pengemudi">Pengemudi</label>
                        <input
                            type="text"
                            class="form-control"
                            id="driver"
                            v-model="ceklog.driver"
                            placeholder="Pengemudi"
                            step="2"
                            required="required"
                            disabled="disabled"
                        />
                    </div>
                    <div class="mb-3">
                        <label class="form-label" for="merkType">MEREK - Type</label>
                        <input
                            type="text"
                            class="form-control"
                            id="merkType"
                            v-model="ceklog.merkType"
                            placeholder="MEREK - Type"
                            required="required"
                            disabled="disabled"
                        />
                    </div>

                    <div class="mb-3">
                        <label class="form-label" for="kmMeter">Kilometer Unit</label>
                        <input
                            type="text"
                            class="form-control"
                            id="kilometerUnit"
                            v-model="ceklog.kilometerUnit"
                            placeholder="Kilometer Unit"
                            disabled="disabled"
                            required="required"
                        />
                    </div>

                    <button
                        type="reset"
                        class="btn btn-outline-danger"
                        @click="closePage"
                    >
                        Close
                    </button>
                </form>
            </div>
        </div>
    </div>
</template>
<script>
import axios from "axios";
import moment from "moment";
export default {
    mounted() {
        if(this.ceklogs!="")
            this.ceklog = JSON.parse(this.ceklogs)

        this.getSarana();
    },
    data() {
        return {
            moment:moment,
            ceklog: {},
            sarana: [],
            vehicle : [],
            users:{},
        };
    },
    props: ["tokens", "url_action","ceklogs"],
    methods: {
        getSarana() {
            this.initDatas();
            axios
                .get("/sarana/lv/show")
                .then((response) => {
                    var v = response.data;
                    if (v != null) {
                        var s = {};
                        var vhc = {};
                        for(var i in v){
                            s[v[i].uidVehicle] = v[i].noLambung + " ("+v[i].noPol+")"
                            vhc[v[i].uidVehicle]= v[i].merek + " ("+v[i].type+")"
                        }
                        this.sarana = s
                        this.vehicle = vhc
                    }
                });
        },
       
        initDatas() {
        },
        closePage(){
            window.close()
        },
        pad(d) {
            return (d < 10) ? '0' + d.toString() : d.toString();
        }
    },
    expose: ["initDatas", "getByIds", "focusInputs"],
};
</script>